import { render, staticRenderFns } from "./LifeDisability.vue?vue&type=template&id=161c8244&"
import script from "./LifeDisability.vue?vue&type=script&lang=js&"
export * from "./LifeDisability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports